import { Add, Remove, Sort } from "@mui/icons-material";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  List,
  ListItem,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useState, useRef } from "react";

import { ACTIONABLE_ITEM_TYPE_STRING } from "../../../../../../../../../../../components/cm/Dashboard/FullPages/ClientDetail/FollowUps/types/actionTypes";
import { useDebouncedEffect } from "../../../../../../../../../../../hooks/useDebounceEffect";
import useService from "../../../../../../../../../../../hooks/useService";
import useToggleDropdown from "../../../../../../../../../../../hooks/useToggleDropdown";
import axios from "../../../../../../../../../../api/axios";
import ShowMoreButton from "../../../../../../../../../../global/ShowMoreButton";

export default function MultiSelectFilterV3({
  title,
  searchTitle,
  selectedItems,
  setActiveItems,
  activeItems,
  setSelectedItems,
  nameKey,
  valueKey,
  apiUrl,
  searchKey,
  orderingVal,
  resetPagination,
  buttonFullW,
  dropdown,
  filterName,
  setFilterState,
}) {
  const [showForm, setShowForm] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [resLimit, setResLimit] = useState(25);
  const [showMoreVisible, setShowMoreVisible] = useState(true);
  const [responseArray, setResponseArray] = useState([]);
  const [loadingRes, setLoadingRes] = useState(false);
  const accordionRef = useRef(null);
  useToggleDropdown(dropdown, accordionRef, () => setShowForm(false));

  const enumRepository = useService("repositories/enum-repository");

  const showMoreElements = (amount) => {
    if (amount <= resLimit) {
      setShowMoreVisible(false);
    } else {
      setShowMoreVisible(true);
    }
  };

  const followUpTypes = async () => {
    const actionTypes = await enumRepository
      .query({
        urlPath: apiUrl,
      })
      .then((arr) => arr.filter((obj) => obj.label !== ACTIONABLE_ITEM_TYPE_STRING[1]));
    showMoreElements(actionTypes.length + 1);

    setResponseArray(actionTypes);
    setLoadingRes(false);
  };

  useDebouncedEffect(
    () => {
      if (!apiUrl || !showForm) {
        return;
      } else {
        setLoadingRes(true);
        if (filterName === "followUpFilter") {
          followUpTypes();
        } else {
          const searchQuery = !searchVal
            ? ""
            : `&${!searchKey ? "search" : searchKey}=${searchVal}`;
          axios
            .get(
              `${apiUrl}limit=${resLimit}&ordering=${
                !orderingVal ? "name" : orderingVal
              }${searchQuery}`,
              {}
            )
            .then((response) => {
              const data = response.data.results;
              showMoreElements(response.data.count);
              setResponseArray(data);
              setLoadingRes(false);
            });
        }
      }
    },
    [resLimit, searchVal, showForm],
    250
  );

  const handleSelectedItem = (event, info) => {
    const compVar = typeof event.target.name === "string" ? event.target.name : +event.target.name;
    if (selectedItems.includes(compVar)) {
      const activeItemName = info[nameKey];
      setActiveItems(activeItems.filter((e) => e !== activeItemName));
      setSelectedItems(selectedItems.filter((e) => e !== compVar));
    } else {
      setActiveItems([...activeItems, info[nameKey]]);
      setSelectedItems([...selectedItems, compVar]);
    }
    if (!resetPagination) {
      return;
    } else {
      resetPagination();
    }
  };

  const truncate = (str, max) => {
    if (!str) {
      return;
    }
    return str.length > max ? str.substring(0, max) + "..." : str;
  };

  return (
    <div ref={accordionRef} className="relative w-full bg-white">
      <div className="flex items-center">
        <Button
          onClick={() => setShowForm(!showForm)}
          className={`p-2 text-left text-[15px] normal-case ${
            buttonFullW ? "w-full justify-between" : "w-full justify-between"
          }`}
        >
          <span className="px-2 text-black">{title}</span>
          {!showForm ? (
            <Add className="mr-2 text-sky-600" />
          ) : (
            <Remove className="mr-2 text-sky-600" />
          )}
        </Button>
      </div>
      {!showForm ? (
        ""
      ) : (
        <>
          {" "}
          <FormControl
            className={`max-h-[20vh] w-[100%] w-full overflow-y-auto ${dropdown ? "px-4 shadow-md" : ""}`}
          >
            {loadingRes ? (
              <CircularProgress color="secondary" className="mx-auto my-4 block" />
            ) : (
              <List className="w-[100%] p-2">
                {selectedItems && selectedItems.length > 0 ? (
                  <ListItem className="mb-4 block border-b border-black px-0">
                    <span className="w-full py-1 text-[16px]">
                      <Sort />
                      &nbsp; Selected {searchTitle}
                    </span>
                    <List>
                      {responseArray
                        .filter((item) => selectedItems.includes(`${item[valueKey]}`))
                        .map((item) => (
                          <ListItem key={item[valueKey]} className="m-0 p-0">
                            <FormControlLabel
                              className="break-all"
                              control={
                                <Checkbox
                                  checked={
                                    !selectedItems
                                      ? false
                                      : selectedItems.includes(`${item[valueKey]}`)
                                        ? true
                                        : false
                                  }
                                  className="text-sm"
                                  onClick={(event) => handleSelectedItem(event, item)}
                                  name={`${item[valueKey]}`}
                                />
                              }
                              label={
                                <Typography className="break-all">
                                  {truncate(item[nameKey], 75)}
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                    </List>
                  </ListItem>
                ) : (
                  ""
                )}
                {!responseArray
                  ? ""
                  : responseArray.map((item) => (
                      <ListItem key={item[valueKey]} className="m-0 p-0">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                !selectedItems
                                  ? false
                                  : selectedItems.includes(`${item[valueKey]}`)
                                    ? true
                                    : false
                              }
                              className="text-sm"
                              onClick={(event) => handleSelectedItem(event, item)}
                              name={`${item[valueKey]}`}
                            />
                          }
                          label={
                            <Typography className="break-all">
                              {truncate(item[nameKey], 75)}
                            </Typography>
                          }
                        />

                        <div
                          className={`h-[15px] w-[15px] rounded-full ${
                            !item.client && item.works_for
                              ? item.works_for === "law_firm"
                                ? "bg-yellow-400"
                                : "bg-purple-600"
                              : ""
                          }`}
                        ></div>
                      </ListItem>
                    ))}
              </List>
            )}
            <ShowMoreButton
              showMoreVisible={showMoreVisible}
              setResLimit={setResLimit}
              resLimit={resLimit}
              showMoreAmt={25}
            />
          </FormControl>
        </>
      )}
    </div>
  );
}
